<template>
    <div>
        <SOSlotBase
        :bg-grey="true"
        :container-name="'list-daftaritem-content'"
    >
        <template v-slot:title-bar>
            <SOTitleBar page-title="Daftar Item" type="back" @back="back" :showSearch="false"/>
        </template>
        <template v-slot:skeleton v-if="isLoadingList">
            <div class="p-x-20 p-t-16">
                <DataItemCardSkeleton/>
            </div>
        </template>
        <template v-slot:content v-if="!isLoadingList && listDataItem.actual.length">
            <div >
                <div class="p-x-20 p-t-16 w-limit">
                    <SOHeaderList
                        :title="'Total ' + (listDataItem.count) + ' Item'"
                        :show-filter="false"
                    />
                    <SOSlotCard :card-type="'shadow'"
                    :dropdownMenu="validateAccess('item.update') || validateAccess('item.delete') ? 'card' : ''"
                    v-for="item, idx in listDataItem.actual"
                    :id="item.iditem"
                    class="m-d-12"
                    :key ="`${idx}-${item.iditem}`"
                    >
                        <template v-slot:card_head>
                            <div class="d-flex-between-center">
                                <span class="f-16 overflow-wrap-anywhere">{{ item.nama }}</span>
                                <img src="../../../../assets/icons/more-horizontal2.svg" alt="" class="">
                            </div>
                        </template>
                        <template v-slot:menu_card>
                                <div>
                                    <div @click="showEditModal(item)" v-if="validateAccess('item.update')">
                                        <a class="dropdown-item icon-1"><span
                                                class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    </div>
                                    <div @click="showDeleteModal(item)" v-if="validateAccess('item.delete')">
                                        <a class="dropdown-item icon-2"><span
                                                class="mar-right-10"><img
                                                    src="../../../../assets/icons/trash-red.svg"></span>Hapus</a>
                                    </div>
                                </div>
                        </template>
                    </SOSlotCard>
                    <div v-if="listDataItem.actual.length < listDataItem.count">
                        <SOLoadMoreLoading
                            :id="'load-more-list-item'"
                            loading
                            @intersect="!isLoadingMore && loadMore()"
                        />
                    </div>
                </div>
            </div>
            <!-- <div v-else>
                    <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
                </div> -->
        </template>
        <template v-if="!listDataItem.actual.length && !isLoadingList" v-slot:empty-state>
            <div>
                <SOEmptyState
                    message="Tidak Ada Data"
                    subMessage="Daftar Item Akan Tampil Di Sini"
                />
            </div>
        </template>
        <template v-slot:modal>
            <DetailItemModalEdit
            @finishedEdit="reload()"
            ref="modalEdit"
            />  
            <DetailItemModalHapus
            ref="modalDelete"
            @finishedDelete="reload()"
            />
        </template>
    </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import conn from "@/store/utils/connection";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotCard from '@/so-components/global/slot/SOSlotCard';
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import FilterSorting from "@/component-items/FilterSorting";
import DataItemCardSkeleton from './components/DataItemCardSkeleton';
import DetailItemModalEdit from './modal/DetailitemModalEdit';
import DetailItemModalHapus from './modal/DetailItemModalHapus';
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
    name: "DaftarItem",
    components: {
        SOTitleBar,
        FilterSorting,
        SOLoadMoreLoading,
        SOSlotBase,
        SOSlotCard,
        SOHeaderList,
        DataItemCardSkeleton,
        DetailItemModalEdit,
        DetailItemModalHapus,
        SOEmptyState,
        ErrorMessage
    },
    data() {
        return {
            query: {},
            isShowLoadMore: true,
            isLoading: false,
            isLoadingMore: false,
            isLoadingList: true
        }
    },
    methods: {
        ...mapActions({
            getDataItem: `daftarItemModule/getDataItem`
        }),
        async getData() {
            const idoutlet = this.$route.params.idoutlet
            console.log(idoutlet)
            this.query = {
                idoutlet: idoutlet,
                limit: 20,
                offset: 0
            }
            this.isLoadingList = true
            await this.getDataItem(this.query)
            //this.$store.commit('daftarItemModule/setListDataItem', response.data.actual)
            if(this.listDataItem.actual.length < 20) {
                this.isShowLoadMore = false
            }
            this.isLoadingList = false
        },
        async loadMore() {
            console.log('loadMore')
            this.isLoadingMore = true
            this.query.offset = this.listDataItem.actual.length
            await this.getDataItem(this.query);
            this.isLoadingMore = false
        },
        back() {
            this.$router.push("/addOutlet/"+this.$route.params.idoutlet)
        },
        showEditModal(item) {
            this.$refs.modalEdit.open(item);
        },
        showDeleteModal(item) {
            this.$refs.modalDelete.open(item);
        },
        reload(){
            this.getData()
        },
        getDataCount() {

        },
    },
    computed: {
    ...mapGetters("daftarItemModule", {
            listDataItem: "listDataItem",
        }),
    },
    mounted() {
        this.getData()
    }
}
</script>